import { c as _c } from "react/compiler-runtime";
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { ContactWorkflowAction } from 'modules/contacts/contact-page/types/contact-workflow-step-action-interface';
import { ContactWorkflowStepActionEnum } from 'modules/contacts/contact-page/enums/contact-workflow-step-action-enum';
export const ContactWorkflowActionContent = t0 => {
  const $ = _c(21);
  const {
    action
  } = t0;
  const {
    t
  } = useLocoTranslation();
  switch (action.type) {
    case ContactWorkflowStepActionEnum.AddTag:
    case ContactWorkflowStepActionEnum.RemoveTag:
      {
        let t1;
        if ($[0] !== action.tag.name) {
          t1 = <>{action.tag.name}</>;
          $[0] = action.tag.name;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case ContactWorkflowStepActionEnum.SubscribeToCampaign:
    case ContactWorkflowStepActionEnum.UnsubscribeFromCampaign:
      {
        let t1;
        if ($[2] !== action.campaign.name) {
          t1 = <>{action.campaign.name}</>;
          $[2] = action.campaign.name;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case ContactWorkflowStepActionEnum.SendEmailToSpecificAddress:
      {
        let t1;
        if ($[4] !== action.emailMessageWithRecipient.mailing.currentEmail.subject) {
          t1 = <>{action.emailMessageWithRecipient.mailing.currentEmail.subject}</>;
          $[4] = action.emailMessageWithRecipient.mailing.currentEmail.subject;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case ContactWorkflowStepActionEnum.SendEmail:
      {
        let t1;
        if ($[6] !== action.systemeEmail.subject) {
          t1 = <>{action.systemeEmail.subject}</>;
          $[6] = action.systemeEmail.subject;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case ContactWorkflowStepActionEnum.SendWebhook:
      {
        let t1;
        if ($[8] !== t) {
          t1 = t("dashboard.automation_rule.webhook_url");
          $[8] = t;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        const t2 = `${t1}: ${action.webhookUrl}`;
        let t3;
        if ($[10] !== t2) {
          t3 = <span>{t2}</span>;
          $[10] = t2;
          $[11] = t3;
        } else {
          t3 = $[11];
        }
        return t3;
      }
    case ContactWorkflowStepActionEnum.RevokeAccessToCourse:
    case ContactWorkflowStepActionEnum.EnrollInCourse:
      {
        let t1;
        if ($[12] !== action.course.name) {
          t1 = <>{action.course.name}</>;
          $[12] = action.course.name;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        return t1;
      }
    case ContactWorkflowStepActionEnum.EnrollInCourseBundle:
    case ContactWorkflowStepActionEnum.RevokeAccessToCourseBundle:
      {
        let t1;
        if ($[14] !== action.courseBundle.name) {
          t1 = <>{action.courseBundle.name}</>;
          $[14] = action.courseBundle.name;
          $[15] = t1;
        } else {
          t1 = $[15];
        }
        return t1;
      }
    case ContactWorkflowStepActionEnum.GrantAccessToCommunity:
    case ContactWorkflowStepActionEnum.RevokeAccessToCommunity:
      {
        let t1;
        if ($[16] !== action.community.name) {
          t1 = <>{action.community.name}</>;
          $[16] = action.community.name;
          $[17] = t1;
        } else {
          t1 = $[17];
        }
        return t1;
      }
    case ContactWorkflowStepActionEnum.AssignPipelineStage:
      {
        let t1;
        if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <></>;
          $[18] = t1;
        } else {
          t1 = $[18];
        }
        return t1;
      }
    case ContactWorkflowStepActionEnum.SendSms:
      {
        let t1;
        if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <></>;
          $[19] = t1;
        } else {
          t1 = $[19];
        }
        return t1;
      }
    case ContactWorkflowStepActionEnum.SendToGoogleSheets:
      {
        let t1;
        if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <></>;
          $[20] = t1;
        } else {
          t1 = $[20];
        }
        return t1;
      }
  }
};